module.exports = __webpack_public_path__ + "img/clear.832e2476.svg";